'use client';

import { Skeleton } from '@/components/ui/skeleton';

/**
 * Generic page skeleton for standard content pages
 * Use this as a fallback when no specialized skeleton exists
 * For better UX, create specialized skeletons that match your page layout
 */
export function GenericPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header section skeleton */}
      <div className="space-y-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>

      {/* Content blocks skeleton */}
      <div className="space-y-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    </div>
  );
}
